import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Inline } from 'components/base/Text';
import Icon from 'components/base/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import { Flex } from 'components/base/layout-components';
import GitStreamRepositoriesInfoTooltip from 'views/root/views/home/views/settings/views/RepositoriesV2/gitStreamIntegration/GitStreamRepositoriesInfoTooltip';
import { updateBulkRepositoriesByFilter } from 'common/services/repositories.service';
import {
  getRepositories as getRepositoriesCaller,
  getSensorAuthorizations as getSensorAuthorizationsCaller,
  toggleModal as toggleModalCaller
} from 'state/callers';
import {
  areAllReposConnectedToGitStream,
  areSomeReposConnectedToGitStream
} from 'state/selectors/repositories';
import Checkbox from 'components/base/Checkbox';
import { gitStreamCheckboxTooltips } from '../constants/gitStreamTooltips';
import {
  getDisableGitStreamConfirmationModalOptions,
  onDisconnectGitStream
} from './gitStream.service';
import styled from 'styled-components';

const StyledCheckbox = styled(Checkbox)`
  padding: 0 0.5rem 0 0;
`;
const StyledIcon = styled(Icon)`
  margin-left: 0.3rem;
`;
const GitStreamRepositoriesTableHeader = ({ sensorAuthId }) => {
  const isConnected = useSelector(
    areAllReposConnectedToGitStream(sensorAuthId)
  );

  const [isChecked, setIsChecked] = useState(isConnected);
  const dispatch = useDispatch();

  const isIndeterminate = useSelector(
    areSomeReposConnectedToGitStream(sensorAuthId)
  );
  const toggleModal = args => dispatch(toggleModalCaller(args));
  const getSensorAuthorizations = args =>
    dispatch(getSensorAuthorizationsCaller(args));
  const getRepositories = args => dispatch(getRepositoriesCaller(args));
  const onDisconnect = async () => {
    await onDisconnectGitStream({
      sensorAuthorizationId: sensorAuthId,
      toggleModal,
      getSensorAuthorizations,
      getRepositories
    });
    setIsChecked(false);
  };
  const onCheckBoxChange = async () => {
    if (isChecked) {
      await toggleModal(
        getDisableGitStreamConfirmationModalOptions({
          toggleModal,
          onDisconnect,
          onCancel: () => {
            toggleModal();
            setIsChecked(true);
          }
        })
      );
    } else {
      const payload = { extra: { is_gitstream_enabled: true } };
      await updateBulkRepositoriesByFilter(
        { sensor_authorization_id: sensorAuthId },
        payload
      );
      await getRepositories();
      await getSensorAuthorizations({ withGitStreamEnabled: true });
      setIsChecked(false);
    }
  };
  return (
    <Flex direction='row' items='center'>
      <Tooltip
        title={
          isChecked
            ? gitStreamCheckboxTooltips.ALL_REPOS_CHECKED
            : isIndeterminate
            ? gitStreamCheckboxTooltips.ALL_REPOS_DASH
            : gitStreamCheckboxTooltips.ALL_REPOS_EMPTY
        }
      >
        <div>
          <StyledCheckbox
            checked={isChecked}
            indeterminate={isIndeterminate}
            onChange={onCheckBoxChange}
            color='primary'
          />
        </div>
      </Tooltip>

      <Inline size='medium' weight='400' color='osloGray'>
        gitStream
      </Inline>
      <Tooltip interactive title={<GitStreamRepositoriesInfoTooltip />}>
        <StyledIcon name='infooutlined' size='smaller' />
      </Tooltip>
    </Flex>
  );
};

export default GitStreamRepositoriesTableHeader;
